import './polyfills.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './App.scss';
import './index.css';
import { initDatadogRum } from './monitoring/datadogRum';

initDatadogRum();

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
